// css
import styles from './Introduction.module.css';

// photo
import Me from '../../img/my_photo3.jpg';

const Introduction = () => {
  return (
    <div className={styles.introduction}>
      <div className={styles['introduction-info']}>
        <div className={styles['introduction-info-wrapper']}>
          <h2 className={styles['introduction-intro']}>Hello, My name is</h2>
          <h1 className={styles['introduction-name']}>Ben</h1>
          <div className={styles['introduction-title']}>
            <div className={styles['introduction-title-wrapper']}>
              <div className={styles['introduction-title-item']}>
                前端工程師
              </div>
              <div className={styles['introduction-title-item']}>Angular</div>
              <div className={styles['introduction-title-item']}>React</div>
              <div className={styles['introduction-title-item']}>Vue.js</div>
              <div className={styles['introduction-title-item']}>
                無障礙網站製作經驗
              </div>
            </div>
          </div>
          <div className={styles['introduction-describe']}>
            {/* <p>
              目前任職於高雄哈瑪星科技，年資六個月，工作上使用的框架是Angular5，同時也學習ReactJS。
            </p> */}
            <p>對寫程式充滿熱情，程式是一種將文字和想法結合並具現化的工具。</p>
          </div>
        </div>
      </div>
      <div className={styles['introduction-photo']}>
        <img src={Me} alt="my-pic" className={styles['introduction-img']} />
      </div>
    </div>
  );
};

export default Introduction;
